import webConfig from "web.config.map";
import { InstitutionVoens } from "./constants";

function getStakeholderRoleNames() {
    const currentStakeholder = getStakeholder();
    // const stakeholderMainRoleName = currentStakeholder?.role?.name || "-";
    const stakeholderAdditionalRoleNames = currentStakeholder?.additionalRoles ? currentStakeholder?.additionalRoles.map(item => item?.name) : []
    // const mergedRoleNames = [...stakeholderAdditionalRoleNames, stakeholderMainRoleName]
    return stakeholderAdditionalRoleNames;
}

function getStakeholderRoleName() {
    const currentStakeholder = getStakeholder();
    const stakeholderRoleName = currentStakeholder?.role?.name || "-";
    return stakeholderRoleName;
}

function getStakeholder() {
    const localData = localStorage.getItem('currentStakeholder');
    const currentStakeholder = localData ? JSON.parse(localData) : undefined;
    return currentStakeholder;
}

export const isBorderOperator = () => {
    return Boolean(webConfig.auth.roles.borderOperator.some(role => getStakeholderRoleNames().includes(role)))
}

export const isEcologyOperator = () => {
    return Boolean(webConfig.auth.roles.ecologyOperator.some(role => getStakeholderRoleNames().includes(role)))
}

export const isNationalParkOperator = () => {
    return Boolean(webConfig.auth.roles.nationalParkOperator.some(role => getStakeholderRoleNames().includes(role)))
}

export const isEmergencyOperator = () => {
    return Boolean(webConfig.auth.roles.emergencyOperator.some(role => getStakeholderRoleNames().includes(role)))
}

export const isInternalAffairsOperator = () => {
    return Boolean(webConfig.auth.roles.internalAffairsOperator.some(role => getStakeholderRoleNames().includes(role)))
}

export const isGuideOperator = () => {
    return Boolean(webConfig.auth.roles.guideOperator.some(role => getStakeholderRoleNames().includes(role)))
}

export const isTatoOperator = () => {
    return Boolean(webConfig.auth.roles.tatoOperator.some(role => getStakeholderRoleNames().includes(role)))
}

export const isAccomodationOperator = () => {
    return Boolean(webConfig.auth.roles.accomodationOperator.some(role => getStakeholderRoleNames().includes(role)))
}

export const isSupervisorOperator = () => {
    const result = isEmergencyOperator() || isInternalAffairsOperator() || isNationalParkOperator()
    return Boolean(result)
}

export const hasRight = (rightName) => {
    const stakeholder = getStakeholder()
    // const stakeholderRights = stakeholder?.role?.rights || [];
    const roles = stakeholder?.additionalRoles || [];
    const mappedRoles = roles.map(r => r.rights)
    const allRights = mappedRoles.flat(Infinity);
    const access = allRights.find(r => r.name === rightName)

    // if (!access) {
    //     console.log('PERMISSION NEEDED: ', rightName);
    // }

    return Boolean(access)
}

export const isInstitution = () => {
    const currentStakeholder = getStakeholder();
    const voen = currentStakeholder?.voen;
    const institutionVoenList = Object.values(InstitutionVoens).filter(item => item)
    return Boolean(voen && institutionVoenList.includes(voen))
}
